import React from 'react';
import { useInView } from '@/hooks/useInView';

const TESTIMONIAL_VIDEO = 'https://customer-assets.emergentagent.com/job_ff005761-8ac3-4660-9dad-114860e1014d/artifacts/tvqvuof1_Video.mov';

export const TestimonialSection = () => {
  const [ref, isInView] = useInView();

  return (
    <section data-testid="testimonial-section" className="py-16 lg:py-24 bg-background" ref={ref}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-8 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <p className="text-primary font-semibold text-sm uppercase tracking-widest mb-3">
            Trusted by Google Media Partners
          </p>
          <h3 className="text-foreground text-xl sm:text-2xl font-bold">
            Adel C. | North Peak Media
          </h3>
        </div>
        <div
          className={`rounded-xl overflow-hidden shadow-[var(--shadow-elevated)] bg-foreground/5 transition-all duration-700 delay-150 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <video
            controls
            preload="metadata"
            className="w-full aspect-video"
            playsInline
          >
            <source src={TESTIMONIAL_VIDEO} type="video/quicktime" />
            <source src={TESTIMONIAL_VIDEO} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>
  );
};
